/*************************************************

* BAKER HUGHES COMPANY CONFIDENTIAL

* Unpublished work copyright 2025 Baker Hughes Company.  All rights reserved.

*

* This computer code is proprietary and highly confidential to Baker Hughes Company

* and/or its affiliate(s). It may not be used, disclosed, modified, transferred,

* or reproduced without prior written consent, and must be returned on demand.

**************************************************/
import { useEffect } from 'react';
import {
  useShadowRootElements,
  useTechDocsReaderPage,
} from '@backstage/plugin-techdocs-react';
import { usePermission } from '@backstage/plugin-permission-react';
import { catalogEntityEditPermission } from '@internal/plugin-ssp-permission-common';
import { stringifyEntityRef } from '@backstage/catalog-model';

/**
 * Enable/disbale the edit link on doc based on entity owner permission.
 * This Tech doc addon finds edit doc link and disable it if logged in user is not owner of the linked entity
 * @returns
 */
export const EditDocLinkAddon = () => {
  const { entityRef } = useTechDocsReaderPage();
  const editDocEl = useShadowRootElements<HTMLAnchorElement>([
    "a[title='Edit this page']",
  ]);
  const { allowed, loading: loadingPermission } = usePermission({
    permission: catalogEntityEditPermission,
    resourceRef: entityRef ? stringifyEntityRef(entityRef) : undefined,
  });

  useEffect(() => {
    if (!loadingPermission && !allowed && editDocEl.length > 0) {
      editDocEl[0].href = '#';
      editDocEl[0].style.color = 'rgba(0, 0, 0, 0.26)';
      editDocEl[0].style.cursor = 'default';
      editDocEl[0].addEventListener('click', _event => {
        _event.preventDefault();
      });
    }
  }, [editDocEl, allowed, loadingPermission]);

  return null;
};
